window.ImageCell = function () {
    var el = this;
    var isMoving = false;
    var elsList = {};

    el.remove = function () {
        var images = el.workData.workareas[el.selectWorkareaId].format.images;
        if (images.hasOwnProperty(el.selectId)) {
            el.upImages.unsetUsedImage(images[el.selectId].name);
        }

        delete el._parent.workData.workareas[el.selectWorkareaId].format.images[el.selectId];

        el.selection.hide();
        el.history.add();
    };

    /**
     * @param {Event} event
     */
    el.beginMove = function (event) {
        event.preventDefault();
        isMoving = true;
        el._parent.isTransforming = true;
        document.getElementById('move-image-btn').style.opacity = 0;
        var element = document.getElementById('images-item-' + el.selectWorkareaId + '-' + el.selectId);

        elsList = {
            imageElement: element,
            cellElement: document.getElementById('cell-item-' + el.selectWorkareaId + '-' + el.selectId),
            coord: el.transform.getPosition(element),
            lastX: 0,
            lastY: 0,
            x: 0,
            y: 0
        };
    };

    el.move = function (event) {
        if (isMoving) {
            var movementX = 0;
            var movementY = 0;

            if (event.originalEvent.touches !== undefined) {
                event.preventDefault();
                movementX = elsList.lastX === 0 ? 0 : event.originalEvent.touches[0].pageX - elsList.lastX;
                movementY = elsList.lastY === 0 ? 0 : event.originalEvent.touches[0].pageY - elsList.lastY;
                elsList.lastX = event.originalEvent.touches[0].pageX;
                elsList.lastY = event.originalEvent.touches[0].pageY;
            } else {
                movementX = elsList.lastX === 0 ? 0 : event.clientX - elsList.lastX;
                movementY = elsList.lastY === 0 ? 0 : event.clientY - elsList.lastY;
                elsList.lastX = event.clientX;
                elsList.lastY = event.clientY;
            }

            var reversal = el._parent.workData.workareas[el.selectWorkareaId].format;
            var image = reversal.images[el.selectId];
            var imageElement = elsList.imageElement;
            var posImageElement = el.transform.getArea(imageElement);
            var posCellElement = el.transform.getArea(elsList.cellElement);

            if (
                (
                    posCellElement.x1 >= posImageElement.x1 + movementX
                    && posCellElement.x2 <= posImageElement.x2 + movementX
                    && posCellElement.y1 >= posImageElement.y1 + movementY
                    && posCellElement.y2 <= posImageElement.y2 + movementY
                )
                || el._parent.hasOwnProperty('isTemplater')
            ) {

                movementX /= el.workarea.workAreaScale;
                movementY /= el.workarea.workAreaScale;

                elsList.x += movementX;
                elsList.y += movementY;

                var pos = {
                    x: Math.ceil(elsList.coord.x + elsList.x),
                    y: Math.ceil(elsList.coord.y + elsList.y)
                };

                el.transform.setPosition(imageElement, pos.x, pos.y);

                var rotate = el.transform.getRotate(imageElement);
                image.rotate_angle = rotate.angle;
                image.rotate_x = rotate.x;
                image.rotate_y = rotate.y;

                image.x = pos.x;
                image.y = pos.y;
            }
        }
    };

    el.endMove = function () {
        if (isMoving) {
            isMoving = false;
            document.getElementById('move-image-btn').style.opacity = 1;
            el.history.add();
        }
    };

    el.resize = function (diff) {
        var data = {};
        var reversal = el._parent.workData.workareas[el.selectWorkareaId].format;

        var image = reversal.images[el.selectId];
        var cell = reversal.cells[el.selectId];
        var imageElement = document.getElementById('images-item-' + el.selectWorkareaId + '-' + el.selectId);

        var ratio = image.width / image.height;

        if (
            (
                cell.x >= image.x - diff
                && cell.x + cell.width <= image.x + image.width + diff
                && cell.y >= image.y - parseInt(diff / ratio, 10)
                && cell.y + cell.height <= image.y + image.height + parseInt(diff / ratio, 10)
            )
            || el._parent.hasOwnProperty('isTemplater')
            || image.hasOwnProperty('mask')
        ) {
            data.x = parseInt(image.x) - diff;
            data.y = parseInt(image.y) - parseInt(diff / ratio, 10);
            data.width = parseInt(image.width) + 2 * diff;
            data.height = parseInt(image.height) + parseInt(2 * diff / ratio, 10);

            image.x = data.x;
            image.y = data.y;
            image.width = data.width;
            image.height = data.height;

            imageElement.setAttribute('width', data.width);
            imageElement.setAttribute('height', data.height);
            imageElement.setAttribute('x', data.x);
            imageElement.setAttribute('y', data.y);

            el.history.add();
        }
    };

    el.rotate = function (angle) {
        var element, image;

        image = el._parent.workData.workareas[el.selectWorkareaId].format.images[el.selectId];
        element = document.getElementById('images-item-' + el.selectWorkareaId + '-' + el.selectId);

        // reset position
        el.upImages.reinitImagePosition(el.selectWorkareaId, el.selectType, el.selectId);
        element.setAttribute('x', image.x);
        element.setAttribute('y', image.y);
        element.setAttribute('width', image.width);
        element.setAttribute('height', image.height);

        // add rotate
        el.transform.addRotate(element, angle);
        var rotate = el.transform.getRotate(element);
        image.rotate_angle = rotate.angle;
        image.rotate_x = rotate.x;
        image.rotate_y = rotate.y;

        // reinit position with angle
        el.upImages.reinitImagePosition(el.selectWorkareaId, el.selectType, el.selectId);
        element.setAttribute('x', image.x);
        element.setAttribute('y', image.y);
        element.setAttribute('width', image.width);
        element.setAttribute('height', image.height);

        el.history.add();
    };
};
